import * as React from 'react';

export const MemberFormBody: React.StatelessComponent = ({ children }) => (
	<div className="panel-body">{children}</div>
);
